import { useMutation } from '@tanstack/react-query'
import { fetchMedistreamReport } from '../api'
import { triggerDownload } from '../lib'

export type ReportDownloadResult = {
  filename: string
  recordCount: number
  generatedDate: string | null
}

/**
 * Requests a fresh presigned URL and immediately starts the download.
 *
 * A mutation rather than a query: it has a side effect (rendering the CSV in S3
 * on first request each day) and must run only on an explicit click, since the
 * URL it returns is valid for 300s.
 */
export function useDownloadReport() {
  return useMutation<ReportDownloadResult>({
    mutationFn: async () => {
      const { data } = await fetchMedistreamReport()

      triggerDownload(data.url, data.filename)

      return {
        filename: data.filename,
        recordCount: data.record_count,
        generatedDate: data.generated_date ?? null,
      }
    },
  })
}
